import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const logoutUser = createAsyncThunk(
  "user/logoutUser",
  async (_, thunkAPI) => {
    thunkAPI.dispatch(resetState());
  }
);

const initialState = {
  user: null,
  contact: null,
  proposals: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    resetState: (state) => {
      state.user = null;
    },
    setUser: (state, { payload }) => {
      state.user = payload;
    },
    setContact: (state, { payload }) => {
      state.contact = payload;
    },
    setProposals: (state, { payload }) => {
      state.proposals = payload;
    },
  },
  extraReducers: {},
});
const { actions, reducer } = userSlice;

export const { setUser, resetState, setContact, setProposals } = actions;
export default reducer;

// selectors
export const userSelector = (state) => state.user.user;
export const contactSelector = (state) => state.user.contact;
export const userProposalsSelector = (state) => state.user.proposals;
